module.exports = __webpack_public_path__ + "static/media/login-bottom-shape.3d2e9614.png";